var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2598 1.42162L11.3266 1.38242L11.2506 1.36793C10.7462 1.27189 10.226 1.22132 9.69471 1.22132C4.9929 1.22132 1.18273 5.15279 1.18273 10.0004C1.18273 14.8481 4.9929 18.7795 9.69471 18.7795C12.3646 18.7795 14.7465 17.5113 16.307 15.5278L16.3555 15.4661L16.2785 15.4812C11.7455 16.3717 7.53456 12.7964 7.53456 8.02426C7.53456 5.19486 9.03545 2.7274 11.2598 1.42162ZM11.4597 0.196205L11.4651 0.167615L11.4597 0.196206C12.5437 0.40269 12.7858 1.89696 11.8299 2.45814C9.88899 3.59748 8.68856 5.71419 8.68856 8.02465C8.68856 12.0399 12.2277 15.0644 16.0632 14.311C17.1372 14.0999 17.9009 15.3924 17.2023 16.2801C15.3985 18.5726 12.6745 19.9713 9.69471 19.9713C4.35493 19.9713 0.0291054 15.5059 0.0291054 10.0004C0.0291054 4.49026 4.35946 0.0295327 9.69471 0.0295327C10.2867 0.0295327 10.8775 0.0852203 11.4597 0.196205Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.0582109
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.f85dd5c6.svg";
export { ForwardRef as ReactComponent };